import React from "react";
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/core/styles/makeStyles";
import i18n from "../../../i18nextInitiator";
import {connect} from "react-redux";
import {Typography} from "@material-ui/core";
import Item from "./Item";

/**
 * The function to access persian date lib.
 * @type {*|PersianDateClass|{durationUnit: {week: [string, string, string, string], month: [string, string, string], hour: [string, string, string], year: [string, string, string], millisecond: [string, string, string], day: [string, string, string], minute: [string, string, string], second: [string, string, string]}}|{gregorian: {months, weekdays, monthsShort, weekdaysShort, weekdaysMin}, persian: {months, weekdays, monthsShort, weekdaysShort, persianDaysName, weekdaysMin}}|{gregorian: {months: string[], weekdays: string[], monthsShort: string[], weekdaysShort: string[], weekdaysMin: string[]}, persian: {months, weekdays, monthsShort, weekdaysShort, persianDaysName, weekdaysMin}}|{isNumber: function(*=): boolean, isDate: function(*): boolean, isArray: function(*=): boolean}|{validateInputArray: function(*): boolean}}
 */
const persianDate = require('persian-date');

/**
 * This is the funciton to access translations.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa','general');

/**
 * the function the use styles with JSS.
 * @type {(props?: any) => ClassNameMap<"address"|"title">}
 */
const useStyles = makeStyles((theme) => ({
    box: {
        '& *': {
            margin: ".15rem 0"
        },
    }
}))
/**
 * Redux States.
 * @param state
 */
const mapStateToProps = state => ({ ...state.invoice });
/**
 * This component represents every single item of shipping details. Addresses and time.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ShippingDetails = props => {
    const classes = useStyles();

    return(
        <Grid container className={classes.box}>

            {props.preInvoice && <Grid> <Typography variant={"h6"}>{t('invoice.details-title')}</Typography></Grid>}

            {props.bill ? props.bill.details.map((bill, index)=>{
                    return <Item key={index} bill={bill}/>
                }) :
                <>
                    <Item/>
                    <Item/>
                </>
            }
        </Grid>
    );
};
export default connect(mapStateToProps)(ShippingDetails);